import { render, staticRenderFns } from "./FreeSequHealth.vue?vue&type=template&id=21e6b134&scoped=true&"
import script from "./FreeSequHealth.vue?vue&type=script&lang=js&"
export * from "./FreeSequHealth.vue?vue&type=script&lang=js&"
import style0 from "./FreeSequHealth.vue?vue&type=style&index=0&id=21e6b134&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e6b134",
  null
  
)

export default component.exports